import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div class="poem">
      <p class="poem-block text-center mb-3">* * *</p>
      
      <p class="poem-block mb-3">
        Мой мир разрушен и затоплен, <br/>
        Идёт гигантская волна, <br/>
        Что ещё живо, то взято́ в плен: <br/>
        Не знает милости война.
      </p>

      <p class="poem-block mb-3">
        Но через годы иль столетья <br/>
        Поднимется из тёмных вод <br/>
        То, что в годину лихолетья <br/>
        Саморазрушил мой народ.
      </p>

      <p class="poem-block mb-3">
        Увидят умные потомки <br/>
        Венец бесславного пути: <br/>
        Машин бессмысленных обломки, <br/>
        А Человека не найти…
      </p>

      <p class="poem-block mb-3">
        И удивившись, отвернутся <br/>
        От сей загадки прошлых лет: <br/>
        Ведь надо в прошлое вернуться, <br/>
        Чтобы узнать её ответ.
      </p>

      <p class="poem-block mb-3">
        Но нет ни мщенья, ни прощенья, <br/>
        Уже забыто всё давно. <br/>
        И вот, со вздохом отвращенья, <br/>
        Отправят снова нас на дно. 
      </p>
      
    </div>
    `
  )
}

const itemDate = {
  rus: '26 ноября 2025'
}

const itemName = {
  rus: 'Мой мир разрушен...'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;